<app-breadcrumb   [master]="'Terminale'" [parentName]="'Transakcje'" [name]="'Lista'"></app-breadcrumb>
<div class="terminals-import-row-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="terminals-import-row-list-filters">
    <app-dict-partners
      [multiple]="false" label="Partner"
      class="terminals-import-row-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>


    <app-datepicker
      class="terminals-import-row-list-filter"
      label="Data transakcji od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$transactionAt" name="gte$transactionAt"
    ></app-datepicker>


    <app-datepicker
      class="terminals-import-row-list-filter"
      label="Data transakcji do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$transactionAt" name="lte$transactionAt"
    ></app-datepicker>

    <mat-form-field class="terminals-import-row-list-filter">
      <mat-label>Kwota od</mat-label>
      <input matInput placeholder="Kwota od " name="gte$transferAmount" [(ngModel)]="initialFilters.gte$transferAmount">
    </mat-form-field>

    <mat-form-field class="terminals-import-row-list-filter">
      <mat-label>Kwota do</mat-label>
      <input matInput placeholder="Kwota do" name="lte$transferAmount" [(ngModel)]="initialFilters.lte$transferAmount">
    </mat-form-field>

    <mat-form-field appearance="standard" class="terminals-import-row-list-filter">
      <mat-label> Przypisana struktura </mat-label>
      <mat-select [(ngModel)]="initialFilters.haveFacility" name="haveFacility">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="terminals-import-row-list-filter">
      <mat-label> Przypisana polisa  </mat-label>
      <mat-select [(ngModel)]="initialFilters.haveTerminal" name="haveTerminal">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>


  </form>

  <div  class="terminals-import-row-list-buttons">
    <button *ngIf="(userPermissions | async)?.terminals.read_report" [disabled]="!(userPermissions | async).terminals.read_report" mat-raised-button class="report-button" (click)="downloadReport()"> <mat-icon>download</mat-icon> Pobierz raport</button>
    <button (click)="filter()"  mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="rows" >

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> ID </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/terminale/transakcje/szczegoly', element?.uuid]">{{element?.id}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let partner of element.partnerFacility?.partners">
          <p><a class="default-link" [routerLink]="['/partnerzy/szczegoly', partner?.uuid]">{{partner?.shortName}}</a></p>
        </ng-container>
      </td>
    </ng-container>


    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef> Placówka </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/placowki/szczegoly', element.partnerFacility?.address?.uuid]">{{element.partnerFacility?.address.street ? element.partnerFacility?.address.street + ' ' + element.partnerFacility?.address.houseNumber + ', ' + element.partnerFacility?.address?.city : ''}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="transactionAt">
      <th mat-header-cell *matHeaderCellDef> Data transakcji  </th>
      <td mat-cell *matCellDef="let element">
        {{element.transactionAt | date:'y-MM-dd '}}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentTitle">
      <th mat-header-cell *matHeaderCellDef> Tytuł płatności  </th>
      <td mat-cell *matCellDef="let element">
        {{element.paymentTitle }}
      </td>
    </ng-container>

    <ng-container matColumnDef="transferAmount">
      <th mat-header-cell *matHeaderCellDef> Kwota </th>
      <td mat-cell *matCellDef="let element">
        {{(element.transferAmount !== null ? element.transferAmount : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>   </th>
      <td mat-cell *matCellDef="let element" >

        <button
          *ngIf=" (userPermissions | async)?.terminals.write && element.status.key === TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION"
          [disabled]="!(userPermissions | async).terminals.write"
          mat-icon-button matTooltip="Zmiana placówki"  (click)="partnerFacilityChange(element)" color="primary"
        ><mat-icon>edit</mat-icon></button>


      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator  [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
